// --- ERROR TYPES ---

class TruncationError extends Error {
  constructor(message, { rawText, provider } = {}) {
    super(message);
    this.name = "TruncationError";
    this.rawText = rawText;
    this.provider = provider;
  }
}

// --- ERROR CLASSIFICATION ---

const isNonRetryable = (error) => {
  if (error.name === "AbortError") return true;
  const msg = (error.message || "").toLowerCase();
  return (
    msg.includes("invalid api key") ||
    msg.includes("authentication") ||
    msg.includes("unauthorized") ||
    msg.includes("unsupported provider") ||
    msg.includes("permission") ||
    msg.includes("403") ||
    // Rate limit / quota exhaustion. Our retry backoff is only 1-4s, but
    // providers ask for far longer (Google's free-tier daily cap returns
    // retryDelay ~40s and won't clear until reset) — so retrying can't
    // succeed within our window and only burns more of the user's quota.
    // Fail fast and let the user act on it.
    msg.includes("429") ||
    msg.includes("too many requests") ||
    msg.includes("rate limit") ||
    msg.includes("quota") ||
    msg.includes("resource_exhausted")
  );
};

export { TruncationError, isNonRetryable };
